export class WeekCalendar {
    /**
     *
     */
    constructor(_weekday:string) {
        
        this.WeekDay=_weekday;
    }
    WeekDay: string; 
    H0?: Color=new Color(0);
    H1?: Color=new Color(1);
    H2?: Color=new Color(2);
    H3?: Color=new Color(3);
    H4?: Color=new Color(4);
    H5?: Color=new Color(5);
    H6?: Color=new Color(6);
    H7?: Color=new Color(7);
    H8?: Color=new Color(8);
    H9?: Color=new Color(9);
    H10?:Color=new Color(10);
    H11?:Color=new Color(11);
    H12?:Color=new Color(12);
    H13?:Color=new Color(13);
    H14?: Color =new Color(14);
    H15?: Color =new Color(15);
    H16?: Color =new Color(16);
    H17?: Color =new Color(17);
    H18?: Color =new Color(18);
    H19?: Color =new Color(19);
    H20?: Color =new Color(20);
    H21?: Color =new Color(21);
    H22?: Color =new Color(22);
    H23?: Color = new Color(23); 

}
class Color{
    val:number;
    color?:'#fffff';
     
    constructor(_val:number) {
        this.val=_val; 
        this.color='#fffff';
        
    }
}
